/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiServerExceptionResponse,
  RequestBillingPortalResponse,
  StripeBillingPortal,
  StripeBillingPortalConfiguration,
  StripePlan,
} from '../models/index';
import {
    ApiServerExceptionResponseFromJSON,
    ApiServerExceptionResponseToJSON,
    RequestBillingPortalResponseFromJSON,
    RequestBillingPortalResponseToJSON,
    StripeBillingPortalFromJSON,
    StripeBillingPortalToJSON,
    StripeBillingPortalConfigurationFromJSON,
    StripeBillingPortalConfigurationToJSON,
    StripePlanFromJSON,
    StripePlanToJSON,
} from '../models/index';

export interface StripeApiCreateBillingPortalRequest {
    stripeBillingPortalConfiguration?: StripeBillingPortalConfiguration;
}

/**
 * 
 */
export class StripeApi extends runtime.BaseAPI {

    /**
     * Create a Stripe Billing Portal
     */
    async createBillingPortalRaw(requestParameters: StripeApiCreateBillingPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeBillingPortal>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/stripe/createBillingPortal`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StripeBillingPortalConfigurationToJSON(requestParameters['stripeBillingPortalConfiguration']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeBillingPortalFromJSON(jsonValue));
    }

    /**
     * Create a Stripe Billing Portal
     */
    async createBillingPortal(requestParameters: StripeApiCreateBillingPortalRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeBillingPortal> {
        const response = await this.createBillingPortalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available plans
     */
    async getAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StripePlan>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/stripe/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StripePlanFromJSON));
    }

    /**
     * Get all available plans
     */
    async getAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StripePlan>> {
        const response = await this.getAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all available Agency plans
     */
    async getAllAgencyPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/stripe/agencyPlans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get all available Agency plans
     */
    async getAllAgencyPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAllAgencyPlansRaw(initOverrides);
    }

    /**
     * Get the currently active/available Coupon
     */
    async getCouponRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/stripe/coupons/wp`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get the currently active/available Coupon
     */
    async getCoupon(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCouponRaw(initOverrides);
    }

    /**
     * Create a Stripe Billing Portal
     */
    async requestBillingPortalRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestBillingPortalResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/stripe/requestBillingPortal`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestBillingPortalResponseFromJSON(jsonValue));
    }

    /**
     * Create a Stripe Billing Portal
     */
    async requestBillingPortal(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestBillingPortalResponse> {
        const response = await this.requestBillingPortalRaw(initOverrides);
        return await response.value();
    }

}
